// modules
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { addModal } from 'weblite-web-modal-viewer'
// component
import { ProfileCompletionWarning } from './profile-completion-warning'

const COMPONENT_ID = 'profileCompletionWarning'

export const showProfileCompletionWarning = () => addModal({ id: COMPONENT_ID })

export default {
  [COMPONENT_ID]: {
    Component: ProfileCompletionWarning,
  },
}
